import {
  collection,
  getDocs,
  doc,
  getDoc,
  deleteDoc,
  updateDoc,
  arrayUnion,
  setDoc,
} from "firebase/firestore";
import db from "../firebase";

//Note: Does not appear to be in use (IF WE EVER WANT TO CLEAN UP INVENTORY FOR ANY REASON USE THIS FUNCTION)
// This is to remove a document from newDevices if it was already assigned
export const cleanNewDevices = async () => {
  try {
    // Just await the fetchNewDevices call
    const newDevices = await fetchNewDevices();

    // Fetch all organizations
    const organizationsRef = collection(db, "organizations");
    const organizationsSnapshot = await getDocs(organizationsRef);
    const organizations = organizationsSnapshot.docs.map((doc) => doc.data());

    for (let newDevice of newDevices) {
      const deviceId = newDevice.id;
      //   console.log(`Device: ${JSON.stringify(newDevice)}`);
      //   console.log(`Device: ${deviceId}`);

      // Check if the deviceId is present in any organization's list of devices
      let found = false;
      let org;
      for (let organization of organizations) {
        // console.log(`Organization devices: ${organization.devices}`);
        if (organization.devices && organization.devices.includes(deviceId)) {
          found = true;
          org = organization;
          break;
        };
      };

      // If the deviceId is found in any organization's list, delete it from newDevices
      if (found) {
        console.log(`newDevice with id: ${deviceId} found in ${org}`);
        await db.collection("newDevices").doc(deviceId).delete();
        console.log(`Deleted newDevice with id: ${deviceId}`);
      };
    };
    console.log("Finished checking and deleting newDevices.");
  } catch (error) {
    console.error("Error checking and deleting newDevices:", error);
  };
};

export const fetchNewDevices = async () => {
  try {
    // Fetch all newDevices
    const newDevicesRef = collection(db, "newDevices");
    const newDevicesSnapshot = await getDocs(newDevicesRef);
    const newDevices = newDevicesSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return newDevices;
  } catch (error) {
    console.error("Error fetching newDevices:", error);
    return [];
  }
};

export const fetchAllOrganizations = async () => {
  try {
    // Fetch all organizations
    const organizations = [];
    const organizationsRef = collection(db, "organizations");
    const organizationsSnapshot = await getDocs(organizationsRef);
    organizationsSnapshot.forEach((doc) => {
      const docData = doc._document.data.value.mapValue.fields;
      organizations.push(docData);
    });
    return organizations;
  } catch (error) {
    console.error("Error fetching organizations:", error);
    return [];
  }
};

export const deleteNewDevice = async (id) => {
  try {
    const docRef = doc(db, "newDevices", id);
    await deleteDoc(docRef);
    console.log("Document deleted with ID: ", id);
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
};

//NOT USED ANYMORE DEPRECATED AND INCLUDED IN createOutletsInOrganization function
// export const assignDeviceToOrganization = async (orgId, deviceId) => {
//   try {
//     // Fetch the device details
//     const newDeviceRef = doc(db, "newDevices", deviceId);
//     const deviceDoc = await getDoc(newDeviceRef);

//     if (!deviceDoc.exists()) {
//       throw new Error("Device does not exist");
//     }

//     const deviceName = deviceDoc.data().device;

//     // Update the organization's document
//     const organizationRef = doc(db, "organizations", orgId);
//     await updateDoc(organizationRef, {
//       devices: arrayUnion(deviceName),
//     });

//     console.log(`Device ${deviceName} assigned to organization ${orgId}`);
//   } catch (error) {
//     console.error("Error assigning device to organization:", error);
//   }
// };

export const createOutletsInOrganization = async (
  orgId,
  deviceDocIds,
  activationDate,
  setOutletsToAdd,
) => {
  const failedDevices = [];
  const successfullyCreatedDevices = [];

  const promises = deviceDocIds.map(async (docId) => {
    try {
      const newDeviceRef = doc(db, "newDevices", docId);
      const deviceDoc = await getDoc(newDeviceRef);

      if (!deviceDoc.exists()) {
        throw new Error(`Device ${docId} does not exist`);
      };

      const device = deviceDoc.data().device;
      let names = [];

      if (device.startsWith("Ac")) {
        names = [`${device}_0`];
      } else if (device.startsWith("Br") || device.startsWith("Tr")) {
        names = [`${device}_0`, `${device}_1`];
      };

      // Create one or two outlets in parallel for this device
      const outletPromises = names.map(async (name) => {
        const outletData = {
          activationDate: activationDate,
          device: device,
          id: name,
          name: device,
          productType: "",
          orgID: orgId,
          imageURl: false,
          deviceNumber: 1,
        };

        const outletDocRef = doc(collection(db, "outlets"));
        await setDoc(outletDocRef, outletData);

        const statusRef = doc(collection(outletDocRef, "Status"), "status");
        const connectionRef = doc(collection(outletDocRef, "connection"), "connection");

        await Promise.all([
          setDoc(statusRef, { status: "On" }),
          setDoc(connectionRef, { connection: true }),
        ]);
      });

      await Promise.all(outletPromises); // Wait for both outlets (if 2) to complete
      successfullyCreatedDevices.push(device);
    } catch (err) {
      console.error(`Error processing device ${docId}:`, err.message || err);
      failedDevices.push(docId);
    }
  });

  // Wait for all devices to finish processing, this is creating the outlets
  await Promise.all(promises);
  // add failed devices back to outletsToAdd array
  if (failedDevices.length > 0) {
    failedDevices.forEach((docId) => {
      console.log(`- Doc ID: ${docId}, could not be added to organization`);
    });
    setOutletsToAdd(failedDevices);
  } else {
    console.log("✅ All devices processed successfully.");
    setOutletsToAdd([]);
  };
  // add successful created devices to org doc
  const successfulDevices = deviceDocIds.filter(id => !failedDevices.includes(id));
  const organizationRef = doc(db, "organizations", orgId);
  await updateDoc(organizationRef, {
    devices: arrayUnion(...successfullyCreatedDevices),
  });
  // delete successfully created outlets from new devices
  const deletePromises = successfulDevices.map(async (docId) => {
    const newDevicesRef = doc(db, "newDevices", docId);
    await deleteDoc(newDevicesRef);
  });

  await Promise.all(deletePromises);
};

